import { render, staticRenderFns } from "./refuse_ship_dialog.vue?vue&type=template&id=21498aaf&scoped=true"
import script from "./refuse_ship_dialog.vue?vue&type=script&lang=js"
export * from "./refuse_ship_dialog.vue?vue&type=script&lang=js"
import style0 from "./refuse_ship_dialog.vue?vue&type=style&index=0&id=21498aaf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21498aaf",
  null
  
)

export default component.exports